const ExplorationUnitType = {
	NURSERY: { value: 'CR', title: 'common.nursery-exploration-unit' },
	FINISHER: { value: 'TR', title: 'common.finisher-exploration-unit' },
  PIGLET: { value: 'UP', title: 'common.piglet-production-unit' },
	WEAN_TO_FINISH: {
		value: 'WF',
		title: 'common.wean-to-finish-exploration-unit'
	}
};

ExplorationUnitType.getAll = () => ([
	ExplorationUnitType.NURSERY,
	ExplorationUnitType.FINISHER,
	ExplorationUnitType.WEAN_TO_FINISH,
  ExplorationUnitType.PIGLET,
]);

ExplorationUnitType.getByValue = value => {
	switch (value) {
		case ExplorationUnitType.NURSERY.value:
			return ExplorationUnitType.NURSERY;
		case ExplorationUnitType.FINISHER.value:
			return ExplorationUnitType.FINISHER;
		case ExplorationUnitType.WEAN_TO_FINISH.value:
			return ExplorationUnitType.WEAN_TO_FINISH;
    case ExplorationUnitType.PIGLET.value:
		 	return ExplorationUnitType.PIGLET;
	}

	return null;
};

export default Object.freeze(ExplorationUnitType);